import { render } from "./PatientNavMenu.vue?vue&type=template&id=ac1ab064"
import script from "./PatientNavMenu.vue?vue&type=script&lang=js"
export * from "./PatientNavMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__